import { render } from "./MemberCardView.vue?vue&type=template&id=42d51904&scoped=true"
import script from "./MemberCardView.vue?vue&type=script&lang=js"
export * from "./MemberCardView.vue?vue&type=script&lang=js"

import "./MemberCardView.vue?vue&type=style&index=0&id=42d51904&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d51904"]])

export default __exports__